export const CRM_PROPERTY_DATE_FORMAT = 'll';
export const CRM_PROPERTY_DATE_TIME_FORMAT = 'll LT z';